<template>
  <div class="rounded-b-lg relative w-full overflow-hidden md:rounded-b-[32px]">
    <RevIllustration
      :key="illustrationSrc"
      alt=""
      class="w-full"
      :height="327"
      :src="illustrationSrc"
      :width="327"
    />

    <div
      class="absolute inset-x-0 bottom-0 flex flex-col gap-8 pb-24 pl-32"
      :class="bgGradientClasses"
    >
      <h4 class="text-static-light-hi heading-2">{{ title }}</h4>

      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { tw } from '@backmarket/utils/string/tw'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  illustrationSrc: string
  title: string
}>()

const bgGradientClasses = tw`bg-cover bg-[linear-gradient(to_bottom,rgba(0,0,0,0),rgba(0,0,0,0.5))] md:bg-[linear-gradient(to_bottom,rgba(0,0,0,0),rgba(0,0,0,0.3))]`
</script>
